var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompressor = function SvgCompressor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1 20h22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 13.375a.75.75 0 0 0 0 1.5zm22 1.5a.75.75 0 0 0 0-1.5zm-3.603-2.96-.723.197zM15.071 10.2l-.724-.197zm-5.597 1.995-.724.198zM1 14.875h.709v-1.5H1zm4.326-2.763.468-1.715-1.447-.394-.468 1.714zm4.871-.114-.544-1.995-1.447.394.544 1.996zm5.053.395.544-1.996-1.447-.394-.544 1.995zm7.75.982h-.709v1.5H23zm-2.88-1.658-.467-1.714-1.447.394.468 1.715zm2.171 1.658a2.25 2.25 0 0 1-2.17-1.658l-1.447.395a3.75 3.75 0 0 0 3.617 2.763zm-6.497-2.978c.335-1.228 2.077-1.228 2.412 0l1.447-.394c-.737-2.702-4.57-2.702-5.306 0zM12 13.375a1.87 1.87 0 0 1-1.803-1.377l-1.447.395A3.37 3.37 0 0 0 12 14.875zm0 1.5a3.37 3.37 0 0 0 3.25-2.482l-1.447-.395A1.87 1.87 0 0 1 12 13.375zm-6.206-4.478c.335-1.228 2.077-1.228 2.412 0l1.447-.394c-.737-2.702-4.57-2.702-5.306 0zM1.71 14.875a3.75 3.75 0 0 0 3.617-2.763l-1.447-.395a2.25 2.25 0 0 1-2.17 1.658z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1 4h22"
  })));
};
export default SvgCompressor;